import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import { PropsWithClassAndChildren } from "../types";
import styles from "./GridCenterContent.module.css";

export const GridCenterContent = React.forwardRef<
  HTMLDivElement,
  PropsWithClassAndChildren
>(function GridCenterContentComponent({ children, className, ...args }, ref) {
  const cx = createClasses([styles.centerContent, className]);

  return (
    <main className={cx} ref={ref} {...args}>
      {children}
    </main>
  );
});
